import { AssetsService } from "app/services/AssetsService";

const BASE_PATH = "/images/ad-intelligence/llms-channels";

export const llmsAssets = {
    chatGptLogo: AssetsService.assetUrl(`${BASE_PATH}/chatgpt.png`),
    googleAiModeLogo: AssetsService.assetUrl(`${BASE_PATH}/google-ai-mode.png`),
    googleAiOverviewLogo: AssetsService.assetUrl(`${BASE_PATH}/google-ai-overview.png`),
    hubspotAvatar: AssetsService.assetUrl(`${BASE_PATH}/hubspot-avatar.png`),
    hubspotPeople: AssetsService.assetUrl(`${BASE_PATH}/hubspot-people.jpg`),
    shoe: AssetsService.assetUrl(`${BASE_PATH}/shoe.jpg`),
};
